import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';
import React from 'react';
import { styled } from 'linaria/react';
import { css } from 'linaria';
import { PagePadding } from '../Layout/MaxWidth';
import { BlogArticleMaxWidth } from './BlogArticle';

const backgroundColor = '#EEE';

const MockImage = styled('div')`
  padding-top: 32%;
  width: 100%;
  background: ${backgroundColor};
`;

export default React.memo(function BlogArticleLoadingState() {
  return (
    <>
      <MockImage />
      <PagePadding>
        <BlogArticleMaxWidth>
          <LoadingLine
            color={backgroundColor}
            widthRem={100}
            heightPx={30}
            className={css`
              width: 100%;
              margin: 15px auto;
            `}
          />
          <LoadingLine
            color={backgroundColor}
            widthRem={100}
            heightPx={20}
            className={css`
              width: 100%;
              margin: 15px auto;
            `}
          />
          <LoadingLine
            color={backgroundColor}
            widthRem={100}
            heightPx={10}
            className={css`
              width: 90%;
              margin: 15px auto;
            `}
          />
          <LoadingLine
            color={backgroundColor}
            widthRem={100}
            heightPx={10}
            className={css`
              width: 95%;
              margin: 15px auto;
            `}
          />
          <LoadingLine
            color={backgroundColor}
            widthRem={100}
            heightPx={5}
            className={css`
              width: 80%;
              margin: 15px auto;
            `}
          />
          <LoadingLine
            color={backgroundColor}
            widthRem={100}
            heightPx={5}
            className={css`
              width: 100%;
              margin: 15px auto;
            `}
          />
          <LoadingLine
            color={backgroundColor}
            widthRem={100}
            heightPx={5}
            className={css`
              width: 95%;
              margin: 15px auto;
            `}
          />
          <LoadingLine
            color={backgroundColor}
            widthRem={100}
            heightPx={5}
            className={css`
              width: 100%;
              margin: 15px auto 15rem;
            `}
          />
        </BlogArticleMaxWidth>
      </PagePadding>
    </>
  );
});
